export var IdStoreCategory;
(function (IdStoreCategory) {
    IdStoreCategory[IdStoreCategory["TournamentPackages"] = 20] = "TournamentPackages";
    IdStoreCategory[IdStoreCategory["MysteryChests"] = 21] = "MysteryChests";
    IdStoreCategory[IdStoreCategory["LoyaltyPackages"] = 12] = "LoyaltyPackages";
    IdStoreCategory[IdStoreCategory["FarmDollarPackages"] = 11] = "FarmDollarPackages";
    IdStoreCategory[IdStoreCategory["TreatShop"] = 19] = "TreatShop";
})(IdStoreCategory || (IdStoreCategory = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/store/IdStoreCategory.tsx
// module id = 324
// module chunks = 3